module.exports = __webpack_public_path__ + "media/images/app/collections/collection-hoop-mobile-2c35167a922d9b32cf614027d7f940d8.webp";